/* eslint-disable */
import {CacheManager, cacheTypeEnumerate} from '@aofl/cache-manager';
import {cookiesConsent, cacheNamespaces, pixelEvents, outboundLinks} from '../constants-enumerate';
import Cookies from 'js-cookie';

/**
 * Contains a list of pixels that need to be triggered globally
 * once a specific event has been triggered.
 */

const globalPixels = () => {
  const pixels = {};

  pixels[pixelEvents.LANDING] = ``;

  if (Cookies.get(cookiesConsent.ANALYTICS) === 'true') {
    pixels[pixelEvents.CONVERSION] = `
      <!-- Google Analytics -->
      <script>
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', 'G-BDHJHKNRRH', 'auto');
      ga('send', 'event', { eventCategory: 'subs', eventAction: 'Submit'});
      </script>
      <!-- End Google Analytics -->
    `;

    pixels[pixelEvents.PROSPECT_REGISTRATION] = `
      <!-- Google Analytics -->
      <script>
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', 'G-BDHJHKNRRH', 'auto');
      ga('send', 'event', { eventCategory: 'minireg', eventAction: 'Submit'});
      </script>
      <!-- End Google Analytics -->
    `;
  }

  if (Cookies.get(cookiesConsent.TARGETING) !== 'true') {
    pixels[pixelEvents.CONVERSION] += `
    <!-- Facebook Pixel Code -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('dataProcessingOptions', ['LDU']);
      fbq('init', '274976323413910');
      fbq('track', 'CompleteRegistration');
      fbq('track', 'Purchase');
      fbq('track', 'Subscribe', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
    </script>
    <!-- End Facebook Pixel Code -->
    `;
  }

  if (Cookies.get(cookiesConsent.TARGETING) === 'true') {
    pixels[pixelEvents.CONVERSION] += `
      <!-- Facebook Pixel Code -->
      <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('dataProcessingOptions', []);
        fbq('init', '274976323413910');
        fbq('track', 'CompleteRegistration');
        fbq('track', 'Purchase');
        fbq('track', 'Subscribe', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
      </script>
      <!-- End Facebook Pixel Code -->

      <!-- Global site tag (gtag.js) - Google Ads: AW-756955732 -->
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-756955732"></script>
      <script>
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-756955732');
        gtag('event', 'conversion', {
          'send_to': 'AW-756955732/ano_COiB8JYBENT0-OgC',
          'value': 1.0,
          'currency': 'USD',
          'transaction_id': ''
        });
      </script>

      <!-- Bing Pixel Code -->
      <script>(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"18003324"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");window.uetq = window.uetq || [];
      const eventConfig = {
        'event_category': 'Subscription',
        'event_label': 'Subscription',
        'event_value': '0'
      };
      window.uetq.push('event', 'Subscription', eventConfig);</script>
      <!-- End Bing Pixel Code -->

      <!-- NCM Pixel Code -->
      <img height="1" width="1" style="border-style:none;" alt="" src="//insight.adsrvr.org/track/conv/?adv=n3rqu49&ct=0:2qx6utl&fmt=3"/>

      <!-- Start Extreme Reach -->
      <script type="text/javascript">
      new Image().src='https://beacons.extremereach.io/cp-conversion?conversion_id=1811';
      </script>
      <noscript>
      <div style="position:absolute;left:0px;top:0px;display:none;" /><img src="https://beacons.extremereach.io/cp-conversion?conversion_id=1811" width="0" height="0" /></div>
      </noscript>
      <script type="text/javascript">
      new Image().src='https://beacons.extremereach.io/cp-conversion?conversion_id=1813';
      </script>
      <noscript>
      <div style="position:absolute;left:0px;top:0px;display:none;" /><img src="https://beacons.extremereach.io/cp-conversion?conversion_id=1813" width="0" height="0" /></div>
      </noscript>
      <!-- End Extreme Reach -->
    `;
  }

  return pixels;
};

const internalPixels = () => {
  const userSessionData = new CacheManager(cacheNamespaces.USER_SESSION, cacheTypeEnumerate.LOCAL);
  const userData = userSessionData.getItem(cacheNamespaces.USER_SESSION);

  const pixelsInternal = {};

  pixelsInternal[pixelEvents.LANDING] = ``;

  if (Cookies.get(cookiesConsent.ANALYTICS) === 'true') {
    pixelsInternal[pixelEvents.CONVERSION] = [];

    pixelsInternal[pixelEvents.PROSPECT_REGISTRATION] = [];
  }

  if (Cookies.get(cookiesConsent.TARGETING) !== 'true') {
    pixelsInternal[pixelEvents.CONVERSION] = [];
  }

  if (Cookies.get(cookiesConsent.TARGETING) === 'true') {
    pixelsInternal[pixelEvents.CONVERSION] = [
      `${outboundLinks.IPV6}?id=${userData?.userUuid}&aofl_product=academy`
    ];

    pixelsInternal[pixelEvents.PROSPECT_REGISTRATION] = [];
  }

  return pixelsInternal;
};

export {
  globalPixels,
  internalPixels
}
